import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const OceanDepthsOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;
  const buttonGlow = 15 + Math.sin((frame / fps) * Math.PI * 1.5) * 10;

  return (
    <div
      style={{
        width: "100%",
        padding: "48px 32px",
        background: "rgba(0,61,107,0.6)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
        border: "1px solid rgba(0,212,255,0.3)",
        borderRadius: "12px",
        boxShadow: "0 0 60px rgba(0,212,255,0.08)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "24px",
      }}
    >
      <div
        style={{
          fontFamily: "'Josefin Sans', sans-serif",
          fontSize: "10px",
          fontWeight: 700,
          color: "#00d4ff",
          letterSpacing: "5px",
          textTransform: "uppercase",
        }}
      >
        🌊 Dive Deeper
      </div>
      <h2
        style={{
          fontFamily: "'Source Serif 4', serif",
          fontSize: "48px",
          fontWeight: 600,
          fontStyle: "italic",
          color: "#e8f8ff",
          lineHeight: 1.35,
          margin: 0,
        }}
      >
        Surface For More
      </h2>
      <div
        style={{
          transform: `scale(${pulseScale})`,
          background: "rgba(0,212,255,0.12)",
          border: "1px solid rgba(0,212,255,0.5)",
          borderRadius: "50px",
          padding: "16px 40px",
          boxShadow: `0 0 ${buttonGlow}px rgba(0,212,255,0.3)`,
        }}
      >
        <span
          style={{
            fontFamily: "'Josefin Sans', sans-serif",
            fontWeight: 700,
            fontSize: "22px",
            color: "#00d4ff",
            letterSpacing: "2px",
          }}
        >
          👉 Follow
        </span>
      </div>
      <div
        style={{
          fontFamily: "'Josefin Sans', sans-serif",
          fontSize: "20px",
          fontWeight: 700,
          color: "rgba(232,248,255,0.7)",
          letterSpacing: "2px",
        }}
      >
        {keywords?.[1] || "@WaterMARK"}
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
